import React, { Component } from 'react'
import JobList from './jobList'

const styles = {
    container: {
        paddingTop: 5,
        paddingLeft: 15,
        paddingRight: 15,
    },
    background: {
        backgroundColor: 'white',
    },
}

class AppJobList extends Component {
    render() {
        return (
            <div className="workorder-wrapper" style={styles.background}>
                <div style={styles.container}>
                    <JobList />
                </div>
            </div>

        )
    }
}

export default AppJobList
